import { omitDeep } from 'deepdash/standalone';
import { DataScienceOptimization, ScheduleType } from 'modules/domains/campaign';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';
import { getHasSendTimeOptimization } from '../../utils';

/**
 * Generates "send campaign now" payload
 */
export const getSendTimeExperimentCampaignPayload = (
  campaign: GraphQLCampaign,
  projectTimeZone: string,
) => {
  const {
    id,
    customQuietHours,
    customRateLimit,
    schedulerMsgParams,
    dataScienceOptimizations,
    mobileAppIds,
  } = campaign;

  const isSTOEnabled = getHasSendTimeOptimization(campaign);

  const stoData = {
    dataScienceOptimizations,
    windowHours: schedulerMsgParams?.windowHours,
    scheduleType: DataScienceOptimization.SendTimeOptimization,
    automaticSendTime: !!schedulerMsgParams?.automaticSendTime || isSTOEnabled,
  };

  const payload = {
    campaignId: id,
    startTime: null,
    customRateLimit: customRateLimit ?? null,
    customQuietHours: customQuietHours ?? null,
    mobileAppIds: mobileAppIds ?? [],
    /**
     * If the campaign has send time experiment, default to the
     * `scheduleType` set within the experiment itself,
     * which is found in `schedulerMsgParams`. If that doesn't
     * exist, then default to project time zone.
     */
    scheduleType: schedulerMsgParams?.scheduleType || ScheduleType.ProjectTimeZone,
    startTimeZone: schedulerMsgParams?.startTimeZone ?? projectTimeZone,
    defaultTimeZone: schedulerMsgParams?.defaultTimeZone ?? projectTimeZone,
    ...(isSTOEnabled && stoData),
  };

  return omitDeep(payload, ['__typename']);
};
